import AccessImport from '../pages/Access';
import ConnectedImport from '../pages/Connected';
import WizardImport from '../pages/Wizard';
import SetupImport from '../pages/Setup';
import { OrganisationPicker } from '../pages/Organisation';

import { integrationTypes } from '../static/constants';
import OrganisationValidator from '../pages/OrganisationValidator';

export enum Pages {
    Access,
    Connected,
    Wizard,
    Settings,
    Setup,
    Organisation,
    Validator,
    Loader
}

const hubSpotRouteMap = new Map();
hubSpotRouteMap.set(Pages.Access, AccessImport);
hubSpotRouteMap.set(Pages.Connected, ConnectedImport);
hubSpotRouteMap.set(Pages.Settings, SetupImport);
hubSpotRouteMap.set(Pages.Setup, SetupImport);
hubSpotRouteMap.set(Pages.Wizard, WizardImport);

const shopifyRouteMap = new Map();
shopifyRouteMap.set(Pages.Access, AccessImport);
shopifyRouteMap.set(Pages.Connected, ConnectedImport);
shopifyRouteMap.set(Pages.Settings, SetupImport);
shopifyRouteMap.set(Pages.Setup, SetupImport);
shopifyRouteMap.set(Pages.Wizard, WizardImport);
shopifyRouteMap.set(Pages.Organisation, OrganisationPicker);
shopifyRouteMap.set(Pages.Validator, OrganisationValidator);

const customConnectionMap = new Map();
customConnectionMap.set(Pages.Access, AccessImport);

const routeMapMap = new Map();
routeMapMap.set(integrationTypes.HUBSPOT, hubSpotRouteMap);
routeMapMap.set(integrationTypes.SHOPIFY, shopifyRouteMap);
routeMapMap.set(integrationTypes.CUSTOM, customConnectionMap);

export default routeMapMap;
